export const QUIZ_AND_SERIES_TITLE_MAX_LENGTH = 48;

/** Stored fallback title for generated quizzes awaiting async title generation. */
export const UNTITLED_QUIZ_STORED_TITLE = 'Untitled Quiz';

export function getQuizOrSeriesTitleLengthError(
  value: string,
  label: 'Quiz title' | 'Series name' = 'Quiz title'
): string | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  if (trimmed.length > QUIZ_AND_SERIES_TITLE_MAX_LENGTH) {
    return `${label} must be ${QUIZ_AND_SERIES_TITLE_MAX_LENGTH} characters or fewer`;
  }

  return null;
}

export function truncateQuizOrSeriesTitle(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) {
    return trimmed;
  }

  if (trimmed.length <= QUIZ_AND_SERIES_TITLE_MAX_LENGTH) {
    return trimmed;
  }

  return `${trimmed.slice(0, QUIZ_AND_SERIES_TITLE_MAX_LENGTH - 3).trimEnd()}...`;
}
